<template>
  <div
    class="bg-white dark:bg-[#111C30] rounded-2xl shadow-sm border border-slate-200/80 dark:border-[#263449] p-8 sm:p-14 text-center max-w-lg mx-auto my-6 relative overflow-hidden"
  >
    <div
      class="absolute -top-12 -right-12 w-32 h-32 bg-blue-50/80 dark:bg-blue-900/10 rounded-full blur-2xl pointer-events-none"
    ></div>
    <div
      class="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-950/40 dark:to-indigo-950/40 border border-blue-100 dark:border-blue-900/40 rounded-2xl flex items-center justify-center mx-auto mb-5 text-blue-600 dark:text-blue-400 shadow-sm"
    >
      <svg
        class="w-8 h-8 sm:w-10 sm:h-10 text-blue-600 dark:text-blue-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.8"
          :d="iconPath"
        ></path>
      </svg>
    </div>
    <h3 class="text-base sm:text-lg font-bold text-slate-800 dark:text-[#F1F5F9] mb-1.5">
      {{ title }}
    </h3>
    <p class="text-xs sm:text-sm text-slate-500 dark:text-[#A6B4C8] max-w-sm mx-auto leading-relaxed">
      {{ description }}
    </p>
  </div>
</template>

<script setup>
  defineProps({
    title: {
      type: String,
      default: "Select a Class to Begin",
    },
    description: {
      type: String,
      default:
        "Choose a class from the dropdown above to view and mark student attendance.",
    },
    iconPath: {
      type: String,
      default:
        "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
    },
  });
</script>
